import React, {ReactElement, useMemo} from 'react';
import {DeviceType} from '../../../../../incase-domain/common/DeviceType.enum';
import {IQuestionReportElement} from '../../../../../incase-domain/elements/question/questionReportElement';
import {IQuestionElements} from '../../../../../incase-domain/elements/question';
import RenderQuestionReport from './RenderQuestionReport';
import QuestionReportPlaceholder from './QuestionReportPlaceholder';
import {buildPreviewQuestionReport} from './buildPreviewQuestionReport';
import {useLinkedQuestionElement} from './useLinkedQuestionElement';
import {IElementTextInput} from '../../../../../incase-domain/elements/textInput';

interface QuestionReportPreviewProps {
    element: IQuestionReportElement;
    device: DeviceType;
}

function QuestionReportPreview({element, device}: QuestionReportPreviewProps): ReactElement {
    const {questionSlide, actualQuestionElement} = useLinkedQuestionElement(element.questionElementId);

    const questionReport = useMemo(() => {
        try {
            return buildPreviewQuestionReport(actualQuestionElement as IQuestionElements | IElementTextInput, questionSlide);
        } catch {
            return null;
        }
    }, [actualQuestionElement, questionSlide]);

    if (!questionReport) {
        return <QuestionReportPlaceholder />;
    }

    return (
        <RenderQuestionReport
            questionReport={questionReport}
            question={actualQuestionElement as IQuestionElements}
            device={device}
            fontFamily={element.fontFamily}
            palette={element.wordCloudPalette}
        />
    );
}

export default QuestionReportPreview;
